import styled from 'styled-components';
import { BREAKPOINTS } from '../../../app/appConstants';

export const CashierWrapperStyled = styled.div`
    background: var(--app-bg-modal-color);
`;

export const CashierContentWrapperStyled = styled.div`
    flex: 1 1 auto;
    display: flex;
    flex-direction: row;
    overflow: hidden;

    @media (max-width: ${BREAKPOINTS.medium}px) {
        flex-direction: column;
    }
`;

export const CashierContentSideStyled = styled.div`
    min-width: 200px;
    flex-basis: 200px;
    padding: 16px;
    border-right: 1px solid #42456c;
`;

export const CashierContentBalanceBoxStyled = styled.div`
    margin: 16px 0 24px 16px;
`;

export const CashierContentBalanceHeaderStyled = styled.div`
    color: var(--brand-color);
    line-height: 24px;
`;

export const CashierContentBalanceHeaderBadgeStyled = styled.div`
    background-color: var(--brand-color);
    border-radius: 2px;
    line-height: 24px;
    color: black;
    padding: 0 4px;
    display: inline-block;

    @media (max-width: ${BREAKPOINTS.medium}px) {
        float: none;
    }
`;

export const CashierContentBalanceAmountStyled = styled.div`
    font-size: 24px;
    font-weight: 700;
    line-height: 32px;

    &.text-color-secondary {
        color: var(--text-color-secondary);
    }
`;

export const CashierContentBalanceTitleStyled = styled.div`
    color: var(--text-color-secondary);
`;

export const CashierContentBalanceContainerStyled = styled.div`
    min-height: 114px;
`;

export const CashierContentContainerStyled = styled.div`
    flex: 1 1 auto;
    overflow: auto;

    display: flex;
    flex-direction: row;

    > * {
        flex: 1 1 50%;
    }
    
    label, .amount-editor-label {
        font-weight: 700;
        font-size: 16px;
        color: var(--color-white);
    }

    @media (max-width: ${BREAKPOINTS.medium}px) {
        margin-top: 16px;
        flex-direction: column;
        label, .amount-editor-label {
            font-weight: 500;
            font-size: 14px;
            color: var(--color-white-60);
        }

        > * {
            flex: unset;
        }

        padding-bottom: 76px;
    }
`;

export const CashierContentLeftStyled = styled.div`
    margin: 16px 8px 16px 16px;
    padding: 16px;
    border-radius: 2px;
    max-height: 70vh;
    overflow-y: auto;

    @media (max-width: ${BREAKPOINTS.medium}px) {
        margin: 0;
        padding: 0 16px 16px;
        max-height: unset;
        overflow-y: unset;
    }
`;

export const CashierContentRightStyled = styled.div`
    display: flex;
    flex-direction: column;
    padding: 16px;
    overflow-y: auto;
    max-height: 70vh;
    margin-top: 16px;
    border-left: 1px solid var(--color-surface-secondary);

    @media (max-width: ${BREAKPOINTS.medium}px) {
        border-left: unset;
        max-height: unset;
        overflow-y: unset;
    }
`;

export const CashierContentTopStyled = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 16px;

    > * {
        flex: 1 1 50%;
    }
`;

export const CashierContentMenuStyled = styled.div`
    @media (max-width: ${BREAKPOINTS.medium}px) {
        display: flex;
        flex-direction: row;
        overflow: auto;
        > * {
            margin: 0 4px;
            white-space: nowrap;
        }
    }

    > * {
        padding: 8px 16px;
        margin-bottom: 8px;
        border-radius: 4px;
        cursor: default;
        font-weight: 500;
        color: #a3a6cc;

        &.active {
            background: #393c5d;
            color: #ffffff;
        }

        &:hover {
            background: #393c5d;
        }
    }
`;

export const CashierContentSelectCountryStyled = styled.div`
    margin-top: 12px;

    display: flex;
    flex-direction: row;

    > * {
        flex: 0 1 50%;
    }

    > *:nth-child(2) {
        text-align: right;
    }

    @media (max-width: ${BREAKPOINTS.medium}px) {
        display: block;

        > *:nth-child(2) {
            text-align: left;
        }
    }
`;

export const TransactionListStyled = styled.div`
    @media (max-width: ${BREAKPOINTS.medium}px) {
        margin-left: -16px;
        margin-right: -16px;
        max-height: 100%;
    }
`;

export const TransactionContentLeftStyled = styled.div`
    display: flex;
    flex-direction: column;
    margin: 16px 0 0 16px;
    padding-right: 16px;
    max-height: 70vh;
    overflow-y: auto;

    @media (max-width: ${BREAKPOINTS.medium}px) {
        max-height: unset;
        overflow-y: unset;
        margin-top: 16px;
        margin-right: 16px;
    }
`;

export const TransactionContentRightStyled = styled.div`
    margin: 16px;
    padding: 16px;
    background-color: var(--app-bg-modal-panel-color);
    border-radius: 2px;
    max-height: 70vh;
    overflow-y: auto;

    @media (max-width: ${BREAKPOINTS.medium}px) {
        max-height: unset;
        overflow-y: unset;
        margin: 16px 0;
    }
`;

export const TransactionItemStyled = styled.div`
    border-bottom: 1px solid #42456c;
    padding: 16px;
    display: flex;
    flex-direction: row;
    align-items: center;

    &.active,
    &:hover {
        background-color: #393c5d;
    }
`;

export const TransactionItemRowStyled = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`;

export const TransactionItemIconStyled = styled.div`
    font-size: 16px;
    width: 24px;
`;

export const TransactionItemContentStyled = styled.div`
    margin: 0 16px;
    flex: 1 1 auto;
`;

export const TransactionItemSideStyled = styled.div`
    //margin-top: 16px;
    color: #a3a6cc;
`;

export const TransactionItemAmountStyled = styled.div`
    font-size: 16px;
    font-weight: 600;

    &.dark {
        color: #a3a6cc;
    }
`;

export const TransactionItemDescrStyled = styled.div`
    font-size: 16px;
    font-weight: 300;
    margin-right: 16px;
`;

export const TransactionItemDateStyled = styled.div`
    color: #a3a6cc;
`;

export const ModalPanelStyled = styled.div`
    margin: 16px;
    background-color: var(--app-bg-modal-panel-color);
    border-radius: 16px;
    padding: 24px;
`;

export const DotLinkStyled = styled.div`
    display: inline-block;
    color: #a3a6cc;
    font-weight: 600;
    border-bottom: 1px dotted #a3a6cc;
    cursor: default;

    &:hover {
    }
`;

export const CountryNameStyled = styled.div`
    margin-bottom: 8px;

    img {
        padding-right: 8px;
    }
`;

export const PaymentMethodButtonStyled = styled.div`
    img {
        padding-right: 8px;
    }

    margin-bottom: 16px;
    border-radius: 2px;
    background-color: #fff;
    color: #000;
    text-align: center;
    cursor: pointer;
    padding: 16px;
    opacity: 0.65;

    @media (max-width: ${BREAKPOINTS.large}px) {
        padding: 8px;
    }

    &.small {
        padding: 8px;
    }

    &.active, &:hover {
        opacity: 1;
    }
`;

export const TransactionInformationContainerStyled = styled.div`
    display: flex;
    padding: 0 16px;
`;

export const TransactionInformationIconWrapperStyled = styled.div`
    font-size: 36px;
    svg {
        fill: var(--color-white-60);
    }
`;

export const TransactionInformationStyled = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 347px;
    margin: 0 auto;
    padding: 24px 16px 16px;
    border-radius: 16px;
    background-color: var(--app-bg-modal-panel-color);
    align-self: center;
    text-align: center;

    svg {
        font-size: 56px;
        margin-bottom: 16px;
    }

    button {
        margin-top: 40px;
        width: 100%;
    }
    
    p {
        color: var(--color-white-95);
        font-size: 14px;
        font-weight: 400;
        margin-bottom: 0;
    }

    @media(max-width: ${BREAKPOINTS.small}px) {
        max-width: unset;
        width: 100%;
    }
`;

export const TransactionsInfoStyled = styled.div`
    margin-top: 36px;
`;

export const TransactionsInfoBoxStyled = styled.div`
    border: 1px solid #42456c;
    border-radius: 2px;
    padding: 8px;
    text-align: center;
`;

export const TransactionsInfoPaymentLogoStyled = styled.div`
    margin-bottom: 8px;

    img {
        display: inline-block;
        border-radius: 2px;
        background-color: white;
        padding: 8px;
        margin-top: -40px;
    }
`;

export const TransactionsInfoDateStyled = styled.div`
    color: white;
`;

export const TransactionsInfoAmountStyled = styled.h4`
    margin-top: 16px;
`;

export const TransactionsInfoStatusStyled = styled.div`
    border-radius: 4px;
    padding: 12px;
    background-color: #42456c;
    text-align: left;

    margin-top: 24px;

    &.success {
        background-color: #14C6791A;
    }

    &.error {
        background-color: #FF646C1A;
    }
`;

export const TransactionsInfoStatusIconStyled = styled.div`
    font-size: 16px;
    margin-right: 8px;
`;

export const TransactionsInfoStatusTextStyled = styled.div`
    h6 {
        line-height: 24px;
        margin-bottom: 0;
    }

    span {
        color: #A3A6CC;
    }

    &.success * {
        color: #14C679;
    }

    &.error * {
        color: #FF858B;
    }
`;

export const TransactionsInfoIdStyled = styled.div`
    margin-top: 16px;
    color: #A3A6CC;
    @media (max-width: ${BREAKPOINTS.small}px) {
        button {
            width: 100%;
        }
    }
`;